import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'

import style from './period.sass'

const items = [{
  value: 'today',
  disabled: ['monthly', 'weekly', 'daily']
}, {
  value: '2d',
  disabled: ['monthly', 'weekly', 'daily']
}, {
  value: '5d',
  disabled: ['monthly', 'weekly']
}, {
  value: '1m',
  disabled: ['monthly']
}, {
  value: '3m',
  disabled: ['minute']
}, {
  value: '6m',
  disabled: ['minute', '10-minute']
}, {
  value: 'ytd',
  disabled: ['minute', '10-minute', 'hourly']
}, {
  value: '1y',
  disabled: ['minute', '10-minute', 'hourly']
}, {
  value: '2y',
  disabled: ['minute', '10-minute', 'hourly']
}, {
  value: '5y',
  disabled: ['minute', '10-minute', 'hourly']
}, {
  value: '10y',
  disabled: ['minute', '10-minute', 'hourly']
}]

@inject('store') @observer
class Period extends Component {
  handleChange = (e) => {
    this.props.store.analysis.setPeriod(e.target.value)
    this.props.store.analysis.loadCandlestick()
  }

  render() {
    const {period, bar_size} = this.props.store.analysis
    return(
      <div styleName='wrapper'>
        {items.map(item =>
          <button
            key={item.value}
            type='button'
            value={item.value}
            onClick={this.handleChange}
            styleName={item.value === period ? 'active' : ''}
            disabled={item.disabled.indexOf(bar_size) !== -1}
          >
            {item.value}
          </button>
        )}
      </div>
    )
  }
}

export default Period
